import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ListPendingTaxUpdateRes } from 'app/interfaces/responses/List/listPendingTaxUpdateRes';
import { PensionService } from 'app/services/api/pension/pension.service';
import { AlertsService } from 'app/services/system/alerts/alerts.service';

@Component({
    selector: 'app-pending-tax-updates',
    templateUrl: './pending-tax-updates.component.html',
})
export class PendingTaxUpdatesComponent implements OnInit {
    dataSource = new MatTableDataSource<ListPendingTaxUpdateRes>();
    tableColumns: string[] = ['id', 'ssn', 'taxUpdateType', 'newValue', 'createdAt'];
    isLoading = true;
    ssnSearchControl = new FormControl('');
    searchedSsn: string | null = null;

    @ViewChild(MatSort) sort!: MatSort;

    constructor(
        private pensionService: PensionService,
        private alertsService: AlertsService
    ) {}

    ngOnInit(): void {
        this.loadPendingTaxUpdates();
    }

    search(): void {
        this.loadPendingTaxUpdates();
    }

    formatSsn(): void {
        const formattedSsn = this.formatSsnValue(this.ssnSearchControl.value);

        if (this.ssnSearchControl.value !== formattedSsn) {
            this.ssnSearchControl.setValue(formattedSsn, { emitEvent: false });
        }
    }

    formatSsnValue(ssn: string | null): string {
        const digits = (ssn ?? '').replace(/\D/g, '').slice(0, 10);
        return digits.length > 6 ? `${digits.slice(0, 6)}-${digits.slice(6)}` : digits;
    }

    getTaxUpdateTypeLabel(taxUpdateType: string): string {
        switch (taxUpdateType) {
            case 'TaxBracket':
                return 'Skattþrep';
            case 'PersonalTaxCredit':
                return 'Persónuafsláttur';
            case 'SpouseTaxCredit':
                return 'Persónuafsláttur maka';
            default:
                return taxUpdateType;
        }
    }

    getTaxBracketLabel(taxBracket: string | null, salaryOther: number | null): string {
        switch (taxBracket) {
            case 'SK1':
                return 'Skattþrep 1';
            case 'SK2':
                return 'Skattþrep 2';
            case 'SK3':
                return 'Skattþrep 3';
            case 'OTHER':
                return `Skattþrep mv. aðrar mán. tekjur ${this.getFormattedAmount(salaryOther ?? 0)}`;
            case null:
                return `Skattþrep mv. aðrar mán. tekjur ${this.getFormattedAmount(salaryOther ?? 0)}`;
            default:
                return taxBracket ?? '';
        }
    }

    private getFormattedAmount(amount: number): string {
        return `${amount.toLocaleString('is-IS').replace(/,/g, '.')} kr.`;
    }

    private loadPendingTaxUpdates(): void {
        this.isLoading = true;
        const ssn = (this.ssnSearchControl.value ?? '').trim();

        this.pensionService.getPendingTaxUpdates(ssn).subscribe({
            next: (res) => {
                this.dataSource = new MatTableDataSource(res.returnItem ?? []);
                this.dataSource.sort = this.sort;
                this.searchedSsn = ssn || null;
                this.isLoading = false;
            },
            error: () => {
                this.isLoading = false;
                this.alertsService.changeAlertErrorMessage('Villa við að sækja óafgreiddar skattaupplýsingar');
                this.alertsService.changeAlertErrorShow(true);
            },
        });
    }
}
